// Schritte und Tastenkürzel des Akquise-Arbeitsplatzes je Phase (AcquisitionPage).

export type WorkspacePhase = 'idle' | 'focus' | 'calling' | 'wrapup' | 'appointment' | 'followup' | 'done';

export const workflowSteps = ['Lead', 'Gespräch', 'Ergebnis', 'Erledigt'];

export function workflowIndex(phase: WorkspacePhase, hasCall: boolean): number {
  switch (phase) {
    case 'idle':
    case 'focus':
      return 0;
    case 'calling':
      return 1;
    case 'wrapup':
      return 2;
    case 'appointment':
    case 'followup':
      return hasCall ? 2 : 0;
    case 'done':
      return 3;
  }
}

export function workflowShortcuts(phase: WorkspacePhase, hasCall: boolean): [string, string][] {
  switch (phase) {
    case 'focus':
      return [
        ['C', 'Anruf starten'],
        ['T', 'Termin eintragen'],
        ['N', 'nächster Lead'],
      ];
    case 'calling':
    case 'wrapup':
      return [
        ['T', 'Termin'],
        ['R', 'Rückruf'],
      ];
    case 'done':
    case 'idle':
      return [['N', 'nächster Lead']];
    default:
      return hasCall ? [] : [['N', 'nächster Lead']];
  }
}
